import { render, staticRenderFns } from "./PreviewViewer.vue?vue&type=template&id=60caa64e&scoped=true&"
import script from "./PreviewViewer.vue?vue&type=script&lang=js&"
export * from "./PreviewViewer.vue?vue&type=script&lang=js&"
import style0 from "./PreviewViewer.vue?vue&type=style&index=0&id=60caa64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60caa64e",
  null
  
)

export default component.exports